import React from "react";
import me from "../../assets/logo/me.png";
import useTitle from "../../Hooks/useTitle";

const About = () => {
  useTitle("About Me");
  return (
    <div className="bg-primary h-full py-28">
      <div className="container mx-auto">
        <div className="flex justify-center">
          <img
            src={me}
            className="w-72 hover:scale-110 hover:rotate-1 transition-all ease-in-out delay-75 duration-500 lg:mx-0 md:mx-auto"
            alt=""
          />
        </div>
        <h2 className="lg:text-2xl md:text-xl font-light text-success md:mx-auto sm:mx-auto mx-auto w-3/4 hover:scale-105 transition-all ease-in-out delay-75 duration-500 lg:text-start md:text-start sm:text-center text-center">
          Hello there! I am Farhan, practicing web development for the past two
          years. This journey has indeed been a roller coaster ride. From being
          excited to pull off unique new features to getting errors, and then
          eventually solving it, is something really worth cherishing, and it is
          what I believe to be the most important part of this learning phase.
          <br />
          <br />
          Within this intricate procedure, music always helps me elevate my
          mind, helps me to unleash my creativity, and what can be more exciting
          than being able to play music yourself? Music and coding. A beautiful,
          lovely duo indeed!!!
        </h2>
        {/* <p className="lg:text-2xl md:text-xl font-semibold mt-14 text-green-500 text-center hover:scale-105 transition-all ease-in-out delay-75 duration-500">
          FIND ME ON
        </p>
        <div className="flex justify-center gap-6 mt-6 items-center">
          <Lottie
            animationData={github}
            className="w-24"
            href="https://github.com/farhanhasindipro25"
          ></Lottie>
          <Lottie animationData={linkedin} className="w-24" href=""></Lottie>
          <Lottie animationData={fb} className="w-24" href=""></Lottie>
        </div> */}
      </div>
    </div>
  );
};

export default About;
